import $ from 'jquery';
import {View} from 'backbone';
import _template from 'dashboard/forms/view-forms-dashboard.ejs';
import eventBus  from 'EventBus.js';

class ViewFormsDashboardView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;

        this.events = {
            'click #recentEditsVFD > ul > li' : 'showFormDetails'
        };

        return this;
    }


    showFormDetails(ev) {
        const formId = ev.currentTarget.attributes["data-id"].value,
            formName = ev.currentTarget.innerText,
              linkId = ev.currentTarget.attributes["data-linkid"].value;
        eventBus.trigger('loadViewForm', formId, formName, linkId);
    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));

        this.delegateEvents();
        return this;
    }
}

export default ViewFormsDashboardView;